<template>
  <section class="favorite-connect-list">
    <div class="favorite-connect-grid">
      <div v-for="listing in shortlists" :key="listing.uuid" class="favorite--project-item">
        <card-owner-connect :listing="listing" :is-shortlist="true" @refresh="refresh" />
      </div>
    </div>
    <pagination
      :push-state="false"
      :meta="meta.pagination"
      @changePage="changePage"
      :maxVisibleButtons="5"
      v-if="meta"
      class="mb-2"
    />
  </section>
</template>

<script>
import CardOwnerConnect from '@/components/utils/card-owner-connect.vue';
import { mapGetters, mapState } from 'vuex';
import Pagination from '@/components/utils/fractal-pagination.vue';

export default {
  components: {
    Pagination,
    CardOwnerConnect,
  },
  data() {
    return {
      projects: [],
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters({}),
    ...mapState({
      shortlists: (state) => state.ownerConnect.inquiries,
      meta: (state) => state.ownerConnect.inquiriesMeta,
    }),
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    async changePage(page) {
      await this.$store.dispatch('ownerConnect/getOwnerConnectInquiries', page);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.favorite-connect-list {
  width: 100%;
}

.favorite-connect-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media #{$tablets} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media #{$phones} {
    grid-template-columns: 1fr;
  }
}
</style>
